import { baseApi } from 'services'

import { ApplicationProfile, Declaration, Profile } from '@/types/unlock'

export const applicationProfileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getApplicationProfileByExternalId: builder.query<ApplicationProfile, string>({
      query: (externalId) => `v1/application-profile/${externalId}/`,
    }),
    createApplicationProfile: builder.mutation<ApplicationProfile, Partial<ApplicationProfile>>({
      query: (profile) => ({
        url: 'v1/application-profile/',
        method: 'POST',
        body: profile,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationProfiles',
        'ApplicationCalcs',
        'Alert',
      ],
    }),
    updateApplicationProfile: builder.mutation<ApplicationProfile, Partial<ApplicationProfile>>({
      query: (applicationProfile) => ({
        url: `v1/application-profile/${applicationProfile.uuid}/`,
        method: 'PATCH',
        body: applicationProfile,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationProfiles',
        'ApplicationCalcs',
      ],
    }),
    deleteApplicationProfile: builder.mutation<void, Partial<ApplicationProfile>>({
      query: (applicationProfile) => ({
        url: `v1/application-profile/${applicationProfile.uuid}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationProfiles',
        'ApplicationCalcs',
        'ApplicationParties',
        'Tradeline',
        'Alert',
      ],
    }),
    updateProfile: builder.mutation<Profile, Partial<Profile>>({
      query: (profile) => ({
        url: `v2/profiles/${profile.uuid}/`,
        method: 'PATCH',
        body: profile,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationProfiles',
        'ApplicationCalcs',
        'Profile',
        'Alert',
        'ApplicationParties',
      ],
    }),
    getSsnUnmasked: builder.query({
      query: (profileUuid) => `v2/profiles/${profileUuid}/get_ssn_unmasked/`,
      providesTags: ['ApplicationProfile', 'Profile'],
    }),
    getStaffProfiles: builder.query({
      query: () => 'v2/profiles?staff',
    }),
    createDeclaration: builder.mutation<Declaration, Partial<Declaration>>({
      query: (declaration) => ({
        url: `v2/declaration/`,
        method: 'POST',
        body: declaration,
      }),
      invalidatesTags: ['Declaration'],
    }),
    updateDeclaration: builder.mutation<Declaration, Partial<Declaration>>({
      query: (declaration) => ({
        url: `v2/declaration/${declaration.uuid}/`,
        method: 'PATCH',
        body: declaration,
      }),
      invalidatesTags: ['Declaration'],
    }),
  }),
})

export const {
  useGetApplicationProfileByExternalIdQuery,
  useCreateApplicationProfileMutation,
  useUpdateApplicationProfileMutation,
  useDeleteApplicationProfileMutation,
  useUpdateProfileMutation,
  useGetSsnUnmaskedQuery,
  useCreateDeclarationMutation,
  useUpdateDeclarationMutation,
  useGetStaffProfilesQuery,
} = applicationProfileApi
